function isClientRequest(clientRequest) {
    return clientRequest.writable && !clientRequest.writableEnded;
}
export default isClientRequest;
